import { motion } from "framer-motion";

function Bridge() {
  return (
    <section className="relative py-32 lg:py-40 overflow-hidden w-screen bg-[#F8F8F8]">
      <div className="container mx-auto max-w-5xl px-6">
        {/* Opening Question */}
        <motion.div
          className="mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2
            style={{
              fontFamily: "League Spartan, sans-serif",
              fontSize: "clamp(2rem, 5vw, 4rem)",
              fontWeight: "900",
              color: "#0A0A0A",
              letterSpacing: "-0.01em",
              lineHeight: "1.1",
              textTransform: "uppercase",
            }}
          >
            So why am I<br />
            <span className="relative inline-block">
              <span className="relative z-10">building this</span>
              <motion.span
                className="absolute bottom-0 left-0 right-0 h-3 lg:h-4"
                style={{ backgroundColor: "#00E5FF", opacity: 0.4 }}
                initial={{ scaleX: 0, transformOrigin: "left" }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
            </span>{" "}
            website?
          </h2>
        </motion.div>

        {/* Main Content */}
        <div className="space-y-8 mb-20">
          <motion.p
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "clamp(1.125rem, 2vw, 1.5rem)",
              color: "#222",
              lineHeight: "1.7",
              maxWidth: "48rem",
            }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            Too often, faith is hidden and treated like a{" "}
            <span className="relative inline-block">
              <span className="relative z-10" style={{ fontWeight: "600" }}>
                Sunday thing
              </span>
              <motion.span
                className="absolute bottom-0 left-0 right-0 h-2"
                style={{ backgroundColor: "#E63946", opacity: 0.3 }}
                initial={{ scaleX: 0, transformOrigin: "left" }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              />
            </span>{" "}
            — something boxed into one day, one place, one version of ourselves.
          </motion.p>

          <motion.p
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "clamp(1.125rem, 2vw, 1.5rem)",
              color: "#222",
              lineHeight: "1.7",
              maxWidth: "48rem",
            }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
            But I believe God calls us to live boldly, to carry His truth and
            love into every part of our lives.
          </motion.p>
        </div>

        {/* Se7ens Statement */}
        <motion.div
          className="mb-20 py-12 border-l-4 pl-8"
          style={{ borderColor: "#00E5FF" }}
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p
            style={{
              fontFamily: "League Spartan, sans-serif",
              fontSize: "clamp(1.5rem, 3vw, 2.5rem)",
              fontWeight: "700",
              color: "#0A0A0A",
              letterSpacing: "0.01em",
              lineHeight: "1.3",
              textTransform: "uppercase",
              marginBottom: "1.5rem",
            }}
          >
            Se7ens is my way
            <br />
            of doing that.
          </p>
          <p
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "clamp(1.125rem, 2vw, 1.5rem)",
              color: "#444",
              lineHeight: "1.7",
            }}
          >
            It's a space to share how God moves, how He completes what He
            begins, and how we can find wholeness in Him —{" "}
            <strong>every day, not just one</strong>.
          </p>
        </motion.div>

        {/* Closing Disclaimer */}
        <motion.div
          className="mb-20"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "clamp(1.125rem, 2vw, 1.5rem)",
              color: "#666",
              lineHeight: "1.7",
              maxWidth: "48rem",
            }}
          >
            It's not a church. It's not a sermon.
            <br />
            I'm not a theologian or an expert — just someone walking this
            journey, learning, questioning, and sharing what I've found along
            the way.
          </p>
        </motion.div>

        {/* Transition Dots */}
        <motion.div
          className="pt-8 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.div
            className="inline-block"
            initial={{ scale: 0 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4, type: "spring" }}
          >
            <div
              className="w-2 h-2 rounded-full mx-auto mb-3"
              style={{ backgroundColor: "#00E5FF" }}
            />
            <div
              className="w-2 h-2 rounded-full mx-auto mb-3"
              style={{ backgroundColor: "#E63946" }}
            />
            <div
              className="w-2 h-2 rounded-full mx-auto"
              style={{ backgroundColor: "#00E5FF" }}
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default Bridge;
